import $ from 'jquery';
import debounce from './utils/debounce';

class Slider {
    constructor (wrapperClass) {
        this.window       = $(window);
        this.wrapperClass = wrapperClass;
        this.$wrapper     = $(wrapperClass);
        this.speed        = 400;

        if (this.$wrapper.length) {
            this.prevClass = `${wrapperClass}__prev-btn`;
            this.prev      = $(this.prevClass);
            this.prev.on('click', $.proxy(this.prevClick, this));

            this.nextClass = `${wrapperClass}__next-btn`;
            this.next      = $(this.nextClass);
            this.next.on('click', $.proxy(this.nextClick, this));

            this.itemClass  = `${wrapperClass}__item`;
            this.$items     = $(this.itemClass);
            this.itemWidth  = this.$items.outerWidth();
            this.itemGutter = parseInt(this.$items.css('margin-right').replace('px', ''), 10);

            this.window.on('resize', () => {
                this.itemWidth = this.$items.outerWidth();

                this.goToStarterSlide();
            });

            $(window).on('resize', debounce(() => {
                this.itemWidth = this.$items.outerWidth();

                this.goToStarterSlide();
            }, 300));

            this.goToStarterSlide();
        }
    }

    goToStarterSlide () {
        for (let i = 0; i < this.$wrapper.length; i++) {
            const $slider       = $(this.$wrapper[i]);
            const $starterSlide = $slider.find(`${this.itemClass}--start-slide`);

            if ($starterSlide.length) {
                const $sliderItems = $slider.find(this.itemClass);
                const slideNumber  = $starterSlide.index();

                $sliderItems.css({
                    'left' : -((this.itemWidth + this.itemGutter) * slideNumber)
                });
            } else {
                this.$items.css('left', '0');
            }

            this.checkToDisableButtons($slider);
        }
    }

    nextClick (e) {
        const $elem        = $(e.currentTarget);
        const $slider      = $elem.closest(this.wrapperClass);
        const $sliderItems = $slider.find(this.itemClass);
        const $lastItem    = $sliderItems.last();

        const lastItemRight = $lastItem.offset().left + $lastItem.outerWidth();
        const buttonRight   = $elem.offset().left + $elem.outerWidth();

        if ((lastItemRight > buttonRight) && !$slider.hasClass('is-sliding')) {
            $sliderItems.animate({
                'left' : `-=${this.itemWidth + this.itemGutter}`
            }, this.speed, () => {
                $slider.removeClass('is-sliding');

                this.checkToDisableButtons($slider);
            });

            $slider.addClass('is-sliding');
        }
    }

    prevClick (e) {
        const $elem         = $(e.currentTarget);
        const $slider       = $elem.closest(this.wrapperClass);
        const $sliderItems  = $slider.find(this.itemClass);
        const firstItemLeft = $sliderItems.first().css('left').replace('px', '');

        if ((firstItemLeft < 0) && !$slider.hasClass('is-sliding')) {
            $sliderItems.animate({
                'left' : `+=${this.itemWidth + this.itemGutter}`
            }, this.speed, () => {
                $slider.removeClass('is-sliding');

                this.checkToDisableButtons($slider);
            });

            $slider.addClass('is-sliding');
        }
    }

    checkToDisableButtons ($slider) {
        const $prevBtn     = $slider.find(this.prev).filter(':visible');
        const $nextBtn     = $slider.find(this.next).filter(':visible');
        const $sliderItems = $slider.find(this.itemClass);

        // Prev
        const firstItemLeft = $sliderItems.first().css('left').replace('px', '');

        // Next
        const $lastItem   = $sliderItems.last();
        const buttonRight = $nextBtn.offset().left + $nextBtn.outerWidth();

        if (firstItemLeft >= 0) {
            $prevBtn.addClass('is-disabled');
        } else {
            $prevBtn.removeClass('is-disabled');
        }

        const lastItemRight = $lastItem.offset().left + $lastItem.outerWidth();

        if (lastItemRight < buttonRight) {
            $nextBtn.addClass('is-disabled');
        } else {
            $nextBtn.removeClass('is-disabled');
        }
    }
}

export default Slider;
